import { useFormik } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { supplierActions } from "reducers/supplierReducer";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";
import Alerts from "utilities/Alerts";
import http from "utilities/http";

function AddSupplier({ name: newSupplierName }) {
	const dispatch = useDispatch();
	const submitAddSupplier = async (values, handlers) => {
		try {
			const addedSupplier = await http({
				method: "POST",
				url: "/suppliers/add",
				data: {
					...values,
				},
			});

			const { message, id } = addedSupplier.data;

			Alerts.success(message);
			handlers.resetForm();

			dispatch(
				supplierActions.addSupplier({
					_id: id,
					...values,
				})
			);
		} catch (ex) {
			Alerts.httpException(ex);
		}
	};
	const addSupplierForm = useFormik({
		initialValues: {
			name: newSupplierName ?? "",
			address: "",
			contactPerson: "",
			contactNo: "",
			vatNo: "",
		},
		onSubmit: submitAddSupplier,
	});
	return (
		<Form onSubmit={addSupplierForm.handleSubmit}>
			<Header as="h2">Add New Supplier</Header>
			<Segment loading={addSupplierForm.isSubmitting}>
				<Grid
					columns={2}
					style={{
						marginTop: "0px",
						marginBottom: "0px",
					}}
				>
					<Grid.Column>
						<Form.Input
							name="name"
							label="Name"
							placeholder="Name of the supplier company"
							value={addSupplierForm.values.name}
							onChange={addSupplierForm.handleChange}
							onBlur={addSupplierForm.handleBlur}
						/>
					</Grid.Column>
					<Grid.Column>
						<Form.Input
							name="vatNo"
							label="VAT/PAN No."
							placeholder="VAT/PAN record of the supplier company"
							value={addSupplierForm.values.vatNo}
							onChange={addSupplierForm.handleChange}
							onBlur={addSupplierForm.handleBlur}
						/>
					</Grid.Column>
				</Grid>
				<Form.Input
					name="address"
					label="Address"
					placeholder="Address of the supplier company"
					value={addSupplierForm.values.address}
					onChange={addSupplierForm.handleChange}
					onBlur={addSupplierForm.handleBlur}
				/>
				<Grid
					columns={2}
					style={{
						marginTop: "0px",
						marginBottom: "0px",
					}}
				>
					<Grid.Column>
						<Form.Input
							name="contactPerson"
							label="Contact Person"
							placeholder="Who do you contact the the supplier?"
							value={addSupplierForm.values.contactPerson}
							onChange={addSupplierForm.handleChange}
							onBlur={addSupplierForm.handleBlur}
						/>
					</Grid.Column>
					<Grid.Column>
						<Form.Input
							name="contactNo"
							label="Contact No."
							placeholder="Contact details"
							value={addSupplierForm.values.contactNo}
							onChange={addSupplierForm.handleChange}
							onBlur={addSupplierForm.handleBlur}
							type="number"
							min="0"
						/>
					</Grid.Column>
				</Grid>
				<Button positive type="submit">
					Add Record
				</Button>
			</Segment>
		</Form>
	);
}

export default AddSupplier;
